import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import AboutUs from "../pages/AboutUs";
import Contact from "../pages/Contact";
import AuthenticateCode from "../pages/AuthenticateCode";
import Injectable from "../pages/Athligo/Injectable";
import Orals from "../pages/Athligo/Orals";
import Suplements from "../pages/Athligo/Suplements";
import Sports from "../pages/Athligo/Sports";
import ShopNow from "../pages/shop-now";


const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<AboutUs />} />
      <Route path="/authenticate" element={<AuthenticateCode />} />
      <Route path="/contact" element={<Contact />} />

      <Route path="/athligo/injectable" element={<Injectable />} />
      <Route path="/athligo/orals" element={<Orals />} />
      <Route path="/athligo/suplements" element={<Suplements />} />
      <Route path="/athligo/sports-nutritions" element={<Sports />} />
      <Route path="/shop" element={<ShopNow />} />
    </Routes>
  );
};

export default AppRoutes;
